import { CONSTANTS } from '../../constants';
import { t } from "i18next";
import { FC, useEffect, useState } from "react";
import ApiService from "services/api";
import { useHistory } from "react-router-dom";
import jwt from 'jwt-decode';
import { usePlatformContext } from "context/platform.context";
import Wrapper from "Components/Common/wrapper";
import { Spin, SpinArea } from "Components/Common/Spin";

interface RedirectValidatorProps {}

export const OAuth2Callback: FC<RedirectValidatorProps> = () => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code') || '';
    const state = params.get('state') || '';
    const auction = params.get('auction') || '';
    const hash = params.get('hash') || '';
    const service = params.get('service') || '';

    const history = useHistory();
    
    const [token, setToken] = useState<string | undefined>();
    const [isInvalidToken, setIsInvalidToken] = useState<boolean>(false);
    const [error, setError] = useState<{ token: string; message: string } | undefined>();

    const resetLocalStorageValues = () => {
        localStorage.removeItem(CONSTANTS.storageMap.FILTERS);
    };

    const setLocal = (key: string, value: string) => {
        localStorage.setItem(key, value);
    };
    const { setIsGetPlatform } = usePlatformContext()

    const { AUTH } = CONSTANTS.storageMap;

    useEffect(() => {
        const getTokenByCode = async () => {
            if (code && state) {
                const response = await ApiService.createTokenByCode(code, state).catch((e) => {
                    setIsInvalidToken(true);

                    if (e.response?.data?.response) {
                        const errMsg = e?.response?.data?.response;
                        const { errorMessage } = errMsg;
                        const token = errMsg.errorToken || 'UNEXPECTED_ERROR';

                        setError({
                            token,
                            message: errorMessage.en ? t(`oauth2.${errorMessage.en}`) : t('oauth2.unexpected-error'),
                        });
                    } else {
                        setError({
                            token: 'UNEXPECTED_ERROR',
                            message: t('oauth2.unexpected-error'),
                        });
                    }
                    return null;
                });

                if (response?.data?.data) {
                    const { data } = response.data;
                    setIsInvalidToken(false);
                    setToken(data.accessToken);
                    setIsGetPlatform(true);
                }
            }
        };
        getTokenByCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, state]);

    useEffect(() => {
        const auth = async () => {
            resetLocalStorageValues();
            if (token && auction && hash) {
                setLocal(
                    `${AUTH}:${hash}`,
                    JSON.stringify({
                        auction,
                        token,
                        hash,
                        service,
                    })
                );

                try {
                    jwt(token);
                    return history.push(`/a/${hash}`)
                } catch (error) {
                    console.log(error);
                    return history.push('404')
                }
            }
        };

        auth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div >
            {isInvalidToken ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height:'100vh'}} >
                    <div style={{ border: '1px #f5c6cb solid', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '20px', textAlign: 'center'}} >
                        <h1 style={{color:'#dc3545'}}>{t('term.error')}</h1>
                        <strong>{error?.message || t('oauth2.unexpected-error')}</strong>
                        <p>  {t('error.contact.support')}</p>
                    </div>
                </div>
            ) : 
            (
                <Wrapper height='100vh'>
                    <SpinArea>
                        <Spin />
                    </SpinArea>
                </Wrapper>
            )}
        </div>
    );
};

